let toolbarToggleButton = document.querySelector(".js-toolbar-toggle");
let toolbarContainer = document.querySelector(".js-toolbar-container");
const toolbarArrow = document.getElementById("toolbar-arrow");


const toggleToolbar = (e) => {
    let target = e.target;
    let nodeContainer = document.getElementById("object-properties");
    if(!target.classList.contains("js-profile-toggle") && target.parentNode === toolbarToggleButton){
        target = target.parentNode;
    }

    if(toolbarContainer.classList.contains("open")){
        toolbarContainer.classList.remove("open");
        toolbarToggleButton.classList.remove("open");
        toolbarArrow.classList.remove("open");
        if(nodeContainer && nodeContainer.classList){
            nodeContainer.classList.remove("toolbar-open");
        }
        addTooltip();
    }else if(target === toolbarToggleButton){
        target.classList.add("open");
        toolbarContainer.classList.add("open");
        nodeContainer.classList.add("toolbar-open");
        toolbarArrow.classList.add("open");
        removeTooltip();
    }
}

const addTooltip = () => {
    if (!toolbarToggleButton.getAttribute('data-toggle')) {
        toolbarToggleButton.setAttribute('data-toggle', 'tooltip');
        toolbarToggleButton.setAttribute('data-delay', '{"show":"500"}');
        toolbarToggleButton.setAttribute('data-placement', 'bottom');
        toolbarToggleButton.setAttribute('title', 'Layout');
        $(toolbarToggleButton).tooltip();
    }
}

const removeTooltip = () => {
    if (toolbarToggleButton.getAttribute('data-toggle')) {
        toolbarToggleButton.removeAttribute('data-toggle');
        toolbarToggleButton.removeAttribute('data-delay');
        toolbarToggleButton.removeAttribute('data-placement');
        toolbarToggleButton.removeAttribute('title');
        $(toolbarToggleButton).tooltip('dispose');
    }
}

if(toolbarToggleButton){
    toolbarToggleButton.addEventListener("click", toggleToolbar);
}


// WEBPACK FOOTER //
// ./scripts/components/toolbar-toggle.js